var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OutgoingReturnForm',{attrs:{"formTitle":"Buat Retur Kekurangan","defaultDescription":"Kekurangan"}})
}
var staticRenderFns = []

export { render, staticRenderFns }